import * as actions from "./actionTypes";

const setSignIn = (payload) => {
  return {
    type: actions.AUTH,
    payload,
  };
};
const setUserDetails = (payload) => {
  return {
    type: actions.SET_USER_DETAILS,
    payload,
  };
};
const setVendorDetails = (payload) => {
  return {
    type: actions.SET_VENDOR_DETAILS,
    payload,
  };
};
const setVehicleList = (payload) => {
  return {
    type: actions.SET_VEHICLE_LIST,
    payload,
  };
};
const setMaterialList = (payload) => {
  return {
    type: actions.SET_MATERIAL_LIST,
    payload,
  };
};

const cleanInitialState = () => {
  return {
    type: actions.CLEAN_STATE,
  };
};
const logout = () => {
  return {
    type: actions.LOGOUT_USER,
  };
};
const setLogoutUserId = (payload) => {
  return {
    type: actions.SET_LOGOUT_USER_ID,
    payload,
  };
};
const removeLogoutUserId = (payload) => {
  return {
    type: actions.REMOVE_LOGOUT_USER_ID,
    payload,
  };
};

const logoutWithoutAPI = () => {
  return {
    type: actions.LOGOUT_USER_WITHOUT_API,
  };
};
const setIsLoggedIn = (payload) => {
  return {
    type: actions.LOGGED_IN,
    payload,
  };
};

export {
  setSignIn,
  setUserDetails,
  setVendorDetails,
  setVehicleList,
  setMaterialList,
  cleanInitialState,
  setLogoutUserId,
  removeLogoutUserId,
  logout,
  logoutWithoutAPI,
  setIsLoggedIn,
};
